import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IZBInaugralIndaba = ({ question, answer }) => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
    const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}

                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}

            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025</h1>

                    <p className="pb-3">Last week, Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025 held in Livingstone, organized by the Higher Education Authority and officiated by The Minister of Education Hon. Douglas M. Syakalima, MP.</p>

                    <p className="pb-3">Our Public Sector Banking Relationship Manager, Christopher Mundopa, joined an insightful panel on “Financing the Development of Modern Infrastructure in Higher Education”, where he highlighted the Bank’s role in driving growth through strategic financing and partnerships with higher learning institutions.</p>

                    <p className="pb-3">Our Livingstone team also showcased our diverse range of retail and corporate banking solutions, reinforcing our unwavering commitment to supporting education, innovation and national development through our expanding branch network and digital platforms.</p>



                    <h2 className="pt-4 pb-4">Gallery</h2>

                    <div className="test news-slider-list-slider row align-items-center pb-4">
                        <Slider {...settings}>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-banner-1.jpg" alt="Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-banner-2.jpg" alt="Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-banner-3.jpg" alt="Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-banner-4.jpg" alt="Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-banner-5.jpg" alt="Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-banner-6.jpg" alt="Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-banner-7.jpg" alt="Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025" />
                            </div>
                            <div>
                                <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-banner-8.jpg" alt="Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025" />
                            </div>
                        </Slider>
                    </div>
                </div>



            </section>

            <CustomerCare />
            <OurStores />

        </>
    );
};

export default IZBInaugralIndaba;